function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.385.154a.526.526 0 000 .745l2.807 2.807H.526a.526.526 0 000 1.053h6.616L4.385 7.515a.526.526 0 10.744.745l3.68-3.68a.526.526 0 000-.745L5.13.155a.526.526 0 00-.744 0z",
  fill: "#F58220",
  fillRule: "nonzero"
});

function SvgIconArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgIconArrowBack;